<div class="attachments-scanner-empty-state">
	<div class="attachments-empty-state-icon" aria-hidden="true">
		<tlk-no-image-icon class="attachments-empty-state-icon-svg tlk-icon_size_l"></tlk-no-image-icon>
	</div>
	<div class="attachments-upload-hint">
		{{ 'Attachments.RxAttachmentsScannerMessage1' | translate }}
		<div class="attachments-scanner-message">
			{{ 'Attachments.RxAttachmentsScannerMessage2' | translate }}
		</div>
	</div>
</div>
